import { defineStore } from 'pinia'
import axios from 'axios'

export const useMultiverseStore = defineStore('multiverse', {
  state: () => ({ 
    data: {},
    loading: false,
  }),
  actions: {
    async loadMultiverse () {
        this.loading = true
        const req = await axios.get('/api/multiverse/')
        this.data = req.data
        this.loading = false
    },
    async saveMultiverse (data) {
        this.loading = true
        await axios.post('/api/multiverse/', data)
        this.loading = false
    },  
  },
})
